export default __webpack_public_path__ + "static/media/logo-beta.c12b1bd1.svg";